import React, { useState } from 'react';
import PropTypes from 'prop-types';
import SmsTextArea from './SmsTextArea';
import DeviceWrapper from '../../Shared/DeviceWrapper';
import SaveFab from '../../Shared/SaveFab';
import SmsExample from './SmsExample';
import encodeBase64 from '../../../../../Helpers/encode';

const SmsTemplateContent = function SmsTemplateContent({
  template = null,
  handleEditTemplateList = () => {},
  handleSave = () => {},
  dynamicElement = null,
}) {
  const [enableSaving, setEnableSaving] = useState(false);

  const handleChangeTemplate = (templateObj) => {
    handleEditTemplateList({ ...template, content: templateObj?.content });
    setEnableSaving(templateObj?.content !== template?.content);
  };

  const handleSaveTemplate = () => {
    handleSave({
      ...template,
      outcomes: template?.outcomes,
      content: encodeBase64(template?.content?.replaceAll('&nbsp;', ' ')),
    });
  };

  return (
    <>
      <SmsTextArea
        template={template}
        dynamicElement={dynamicElement}
        onChangeTemplate={handleChangeTemplate}
      />
      <DeviceWrapper>
        <div
          style={{
            width: '100%',
            height: '85%',
            display: 'flex',
            flexDirection: 'column',
            background: '#fff',
            color: '#111',
            borderRadius: '25px',
          }}
        >
          <SmsExample value={template?.content} />
        </div>
      </DeviceWrapper>
      <SaveFab enableSaving={enableSaving} handleSave={handleSaveTemplate} />
    </>
  );
};

SmsTemplateContent.propTypes = {
  template: PropTypes.object,
  handleEditTemplateList: PropTypes.func,
  handleSave: PropTypes.func,
  dynamicElement: PropTypes.object,
};

export default SmsTemplateContent;
